import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { WebToolsPlatformDataService } from './services/web-tools-platform-data.service';

const baseProviders = [
	WebToolsPlatformDataService
];

@NgModule({
	imports: [
		CommonModule
	]
})

export class WebToolsPlatformModule {
	public static forRoot(): ModuleWithProviders<WebToolsPlatformModule> {
		return {
			ngModule: WebToolsPlatformModule,
			providers: [...baseProviders]
		};
	}

}
